'use es6';

import createAction from 'flux-actions/createAction';
import { FETCHED_SETTINGS, RECEIVED_SETTINGS, REQUESTED_SETTINGS, REQUESTED_SETTINGS_FAILED } from './ActionTypes';
export const requestSettings = createAction(REQUESTED_SETTINGS);
export const receiveSettings = createAction(RECEIVED_SETTINGS, settings => ({
  settings
}));
export const requestedSettingsFailed = createAction(REQUESTED_SETTINGS_FAILED, error => ({
  error
}));
export const fetchSettings = createAction(FETCHED_SETTINGS);